export function buildPopup(title?: string, content?: string) {
	var popupHtml = '';
	if (title) {
		popupHtml += '<h5>' + title + '</h5>';
	}
	if (title && content) {
		popupHtml += '<hr>';
	}
	if (content) {
		popupHtml += content;
	}
	return popupHtml;
};

export function buildBtn(icon: string, label: string, url: string) {
	var btnHtml = '<a href="' + url + '" class="btn btn-default btn-sm margin-5px">';
	btnHtml += icon + ' ' + label + '</a>';
	return btnHtml;
};

export function buildBtnWarning(icon: string, label: string, url: string) {
	var btnHtml = '<a href="' + url + '" class="btn btn-warning btn-sm margin-5px">';
	btnHtml += icon + ' ' + label + '</a>';
	return btnHtml;
};

export function buildFaIcon(icon: string) {
	return '<i class="fa fa-' + icon + '"></i>';
};

export function buildBiIcon(icon: string) {
	return '<i class="bi-' + icon + '"></i>';
};

